module.exports = __webpack_public_path__ + "static/media/middle-school-2.3a6b2b39.jpg";